export default __webpack_public_path__ + "static/media/kit.2099895f.jpg";